import integrationsIcon1 from './images/integrations/icon-1.svg';
import integrationsIcon2 from './images/integrations/icon-2.svg';
import integrationsIcon3 from './images/integrations/icon-3.svg';
import integrationsIcon4 from './images/integrations/icon-4.svg';

const integrations = [
  {
    icon: integrationsIcon1,
    text: 'Send us your size guides in any format. Or we automatically scrape all size tables and product data from your website',
  },
  {
    icon: integrationsIcon2,
    text: 'We inject a custom script that is compatible with any e-commerce platform. No developer required',
  },
  {
    icon: integrationsIcon3,
    text: 'We push updates to a testing environment, review with you and push live. Minimal operational load added to your team',
  },
  {
    icon: integrationsIcon4,
    text: 'You track EyeFitU influence on Conversion rates, AOV and engagement as we provide you with our analytics',
  },
];

export default integrations;
